import { power } from './power.js';
import type { Wake } from './types.js';
import { StudioError } from '#~/error/index.js';

/**
 * Wake up the specified device.
 *
 * @param deviceId - ID of the device to be awakened.
 */
export const wake: Wake = async (deviceId) => {
  try {
    await power(deviceId, true);
  } catch (cause) {
    throw new StudioError('Unable to wake up the device.', { cause });
  }
};
